import { render, staticRenderFns } from "./Specifics.vue?vue&type=template&id=58d2d806&scoped=true&"
import script from "./Specifics.vue?vue&type=script&lang=js&"
export * from "./Specifics.vue?vue&type=script&lang=js&"
import style0 from "./Specifics.vue?vue&type=style&index=0&id=58d2d806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2d806",
  null
  
)

export default component.exports